<template>
  <div class="survey-progress-line" :class="isPC && 'is-pc'">
    <div class="middle-line"></div>
    <div class="step-list">
      <div
        v-for="(item, key) in stepList"
        class="step"
        :class="`step-${item.status}`"
        :key="key"
      >
        <div class="step-icon">
          <i class="iconfont" :class="getIconClass(item)"></i>
        </div>
        <div class="step-label" :class="item.status === 'doing' && 'custom-color'">
          {{ $t(item.labelI18nKey) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    isPC: {
      type: Boolean,
      default: false
    },
    stepList: {
      required: true
    }
  },
  data () {
    return {

    }
  },
  computed: {

  },
  created () {

  },
  methods: {
    getIconClass (item) {
      const status = item.status
      switch (status) {
        case 'finish':
          return 'iconcompleted'
        case 'doing':
          return 'iconongoing custom-color'
        case 'pending':
          return 'iconIncomplete'
        default:
          return 'iconIncomplete'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.survey-progress-line {
  margin: 30px 35px;
  position: relative;

  .middle-line {
    height: 4px;
    width: 85%;
    margin: 0 20px;
    background: #919191;
    position: absolute;
    top: 10px;
  }

  .step-list {
    display: flex;

    .step {
      width: 60px;
      margin: 0 auto;
      text-align: center;

      &.step-finish {
        .step-icon i, .step-label {
          color: #b8b8b8;

          &:not(.custom-color) {
            color: #b8b8b8;
          }
        }
      }

      &:first-child {
        margin-left: 0;
      }

      &:last-child {
        margin-right: 0;
      }

      .step-icon {
        i {
          font-size: 20px;
          position: relative;
          background: #fff;

          &:not(.custom-color) {
            color: #444;
          }
        }
      }

      .step-label {
        &:not(.custom-color) {
          color: #4e4c4d;
        }
      }
    }
  }
}

.survey-progress-line.is-pc {
  .middle-line {
    width: 90%;
    margin: 0 45px;
    top: 13px;
  }

  .step-list {
    .step {
      width: 100px;

      .step-icon {
        i {
          font-size: 28px;
        }
      }

      .step-label {
        font-size: 20px;
      }
    }
  }
}
</style>
